module.exports = __webpack_public_path__ + "static/img/ent-detail-82.e732900.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-82.jpg
// module id = PK9e
// module chunks = 51